import { useState } from "react";
import { Table, Typography, Button, Modal, Alert } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const data = [
    {
        key: 1,
        color: "#198754",
        rango: "≤ 15 %",
        interpretacion: "Cumplimiento cercano al plan"
    },
    {
        key: 2,
        color: "#ffa500",
        rango: "> 15 % y ≤ 35 %",
        interpretacion: "Diferencia moderada"
    },
    {
        key: 3,
        color: "#f20013",
        rango: "> 35 %",
        interpretacion: "Diferencia crítica"
    }
];

const columns = [
    {
        title: "Color",
        dataIndex: "color",
        align: "center",
        render: (color) => (
            <div
                style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: color,
                    margin: "auto",
                    border: "1px solid #ddd"
                }}
            />
        )
    },
    {
        title: "Diferencia (%)",
        dataIndex: "rango",
        align: "center",
        render: (text) => <Text strong>{text}</Text>
    },
    {
        title: "Interpretación",
        dataIndex: "interpretacion"
    }
];

const ConvencionesAvance = () => {

    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                icon={<InfoCircleOutlined />}
                onClick={() => setOpen(true)}
                style={{
                    backgroundColor: "#1677ff",
                    color: "white",
                    borderColor: "#1677ff"
                }}
            >
                Convenciones
            </Button>

            <Modal
                title="Convenciones de interpretación del Avance Ejecutado"
                open={open}
                onCancel={() => setOpen(false)}
                footer={[
                    <Button key="close" onClick={() => setOpen(false)}>
                        Cerrar
                    </Button>
                ]}
                width={600}
            >

                <Alert
                    message="Interpretación del avance"
                    description="El color mostrado en el Avance Ejecutado (E) depende de la diferencia entre el avance programado (P) y el ejecutado (E)."
                    type="info"
                    showIcon
                    style={{ marginBottom: 20 }}
                />

                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    size="small"
                />

            </Modal>
        </>
    );
};

export default ConvencionesAvance;